// This file is AUTOGENERATED, do not edit it manually!!!

export const projectFinancials = {
    actual_billing: 'Coût facturable réel',
    actual_cost: 'Coût réel',
    ActualBillableExpenses: 'Dépenses facturables réelles',
    ActualBillableExpensesShort: 'Dépenses facturables réelles',
    ActualBilledShort: 'Coût réel facturé',
    ActualBillingShort: 'Coût facturable réel',
    ActualBudgetProfitability: 'Rentabilité du budget réelle',
    ActualCost: 'Coût réel',
    ActualCostQtip: 'Coût réel = Coût de main-d\'œuvre réel + Dépenses réelles',
    ActualExpenses: 'Dépenses réelles',
    ActualExpensesListTitle: 'Réelles',
    ActualExpensesShort: 'Dépenses réelles',
    ActualHours: 'Heures réelles',
    ActualLaborBilling: 'Main-d\'œuvre facturable réelle',
    ActualLaborBillingShort: 'Main-d\'œuvre facturable réelle',
    ActualLaborCost: 'Coût réel de la main-d\'œuvre',
    ActualLaborCostShort: 'Coût réel de la main-d\'œuvre',
    add_activities_flat_fees: 'ajouter des coûts fixes pour les activités',
    add_as_actual_expense: 'Ajouter comme dépense réelle',
    add_planned_billable_expenses: 'ajouter des dépenses facturables prévues',
    add_received_payment: 'Ajouter un paiement reçu',
    add_scheduled_payment: 'Ajouter un paiement prévu',
    AddActivitiesBudgets: 'ajouter des budgets d\'activités',
    AddBudgetLabel: 'Ajouter un budget pour ce projet',
    AddPlannedExpenses: 'ajouter des dépenses prévues',
    Amount: 'Montant',
    ApproveTooltip: 'Transfère les dépenses prévues aux dépenses réelles',
    back_to_metrics: 'Retour aux mesures',
    batch_actual_text: 'Ajouter comme dépenses réelles',
    batch_billed_text: 'Marquer comme Facturée',
    batch_operation_failed_description: 'L\'opération n\'a pas pu être achevée pour ces dépenses. Cela peut être dû à leur suppression ou à un manque des autorisations nécessaires pour effectuer des opérations en lien avec elles. Consultez votre administrateur {brandName} pour connaître les causes possibles.',
    batch_operations_failed_description: 'L\'opération n\'a pas pu être achevée pour {0} dépense(s) sur {1}. Cela peut être dû à leur suppression ou à un manque des autorisations nécessaires pour effectuer des opérations en lien avec elles. Consultez votre administrateur {brandName} pour connaître les causes possibles.',
    Billable: 'Facturable',
    Billed: 'Total facturé',
    BilledPercentQtip: 'Total facturé = (Main-d\'œuvre facturée + Dépenses facturées) / EAC facturable * 100 %',
    BilledVsActualCost: 'Coût facturé vs coût réel',
    Billing: 'Facturable',
    BillingHelp: 'Dans la section Facturation, vous pouvez choisir le bon type de facturation pour votre projet et définir un tarif, par exemple horaire, ou un montant fixe pour un projet à coût fixe.',
    BillingSettings: 'Paramètres de facturation',
    BillingSettingsTitle: 'Facturation',
    BillingType: 'Type de facturation',
    BillingTypeLabel: 'Calculer par ',
    BillingUtilization: 'Utilisation de la facturation initiale',
    BudgetedCost: 'Budget total du projet',
    BudgetHelp: 'Dans cette section, vous pouvez voir le budget total du projet composé des budgets de toutes les activités associées, et définir un budget au niveau du projet.',
    CancelTooltip: 'Annuler',
    chart_actual_billing: 'Coût facturable réel',
    chart_actual_cost: 'Coût réel',
    chart_billable_expenses: 'Dépenses facturables',
    chart_billed: 'Total facturé',
    chart_billed_expenses: 'Dépenses facturées',
    chart_eac_billing: 'EAC facturable',
    chart_expenses: 'Dépenses',
    chart_non_billable_expenses: 'Dépenses non facturables',
    chart_payments: 'Paiements reçus',
    chart_scheduled_payments: 'Paiements prévus',
    ContingencyPadding: 'Contingence ',
    Cost: 'Coût total',
    CPI: 'CPI',
    CurrencyLabel: 'Devise',
    CustomerHourlyRateLabel: 'Taux horaire du client',
    Date: 'Date',
    DeletePaymentConfirmation: 'Voulez-vous vraiment supprimer cet enregistrement ?',
    DeleteTooltip: 'Supprimer',
    Description: 'Description',
    DetailedReportTitleTemplate: 'Rapport détaillé pour {0}',
    EAC: 'Estimation à l\'achèvement',
    eac_billing: 'Estimation à l\'achèvement (EAC) facturable',
    eac_cost: 'Coût de l\'estimation à l\'achèvement (EAC)',
    EACBilling: 'EAC facturable',
    EACBillingLong: 'Estimation à l\'achèvement (EAC) facturable',
    EACBillingQtip: 'Estimation à l\'achèvement (EAC) facturable = Coût facturable réel + ETC facturable',
    EACBillingQtipInfo: 'Estimation du montant total facturable, y compris la main-d\'œuvre facturable et les dépenses facturables (réelles + estimation jusqu\'à l\'achèvement (ETC))',
    EACCost: 'Coût de l\'estimation à l\'achèvement (EAC)',
    EACCost_short: 'Coût EAC',
    EACCostQtip: 'Coût estimé à l\'achèvement (EAC) = coût réel + coût ETC',
    EnteredBy: 'Saisi par',
    EstimatedBudgetProfitability: 'Estimation de la rentabilité du budget',
    EstimatedCostVariance: 'Écart de coût estimé',
    EstimatedExpenses: 'Dépenses estimées',
    EstimatedHours: 'Heures estimées',
    EstimatedProfit: 'Bénéfice attendu',
    EstimatedProfitPercentQtip: 'Bénéfice attendu (%) = (EAC facturable - coût EAC) / EAC facturable * 100 %',
    EstimatedProfitQtip: 'Bénéfice attendu = EAC facturable - Coût EAC',
    etc_billing: 'Estimation à l\'achèvement (ETC) facturable',
    etc_cost: 'Coût de l\'estimation à l\'achèvement (ETC)',
    ETCBillableExpenses: 'Dépenses facturables ETC',
    ETCBillableExpensesShort: 'Dépenses facturables ETC',
    ETCBilling: 'ETC facturable',
    ETCBillingShort: 'ETC facturable',
    ETCCost: 'Coût ETC',
    ETCCostShort: 'Coût ETC',
    ETCCosttQtip: 'Coût de l\'estimation à l\'achèvement (ETC) = Coût de la main-d\'œuvre ETC + Dépenses ETC',
    ETCExpenses: 'Dépenses ETC',
    ETCExpensesShort: 'Dépenses ETC',
    ETCLaborBilling: 'Main-d\'œuvre facturable ETC',
    ETCLaborBillingShort: 'Main-d\'œuvre facturable ETC',
    ETCLaborCost: 'Coût de la main-d\'œuvre ETC',
    ETCLaborCostShort: 'Coût de la main-d\'œuvre ETC',
    ExpectedRevenue: 'Revenu attendu',
    expenses: '1#{0} dépense#{0} dépenses',
    expenses_updated_successfully_plural: '1#La dépense a été mise à jour avec succès.#{0} Les dépenses ont été mises à jour avec succès.',
    FeeAmount: 'Montant des frais',
    FlatFee: 'Coût fixe',
    GeneralInfo: 'Informations générales',
    HourlyRate: 'Taux horaire',
    InternalBudget: 'Budget',
    InternalEstimatedCost: 'Coût estimé',
    LaborBilling: 'Main-d\'œuvre facturable',
    LaborCost: 'Coût de la main-d\'œuvre',
    legend_actual: 'Réelles',
    legend_estimated_at_completion: 'Estimation à l\'achèvement',
    log_actual_expense: 'Enregistrer la dépense réelle',
    log_expenses: 'Enregistrer les dépenses',
    log_payments: 'Enregistrer les paiements',
    log_planned_expense: 'Enregistrer les dépenses prévues',
    no_targets: 'Aucune cible à afficher',
    NoActualExpenses: 'Il n\'y a pas de dépenses.',
    None: 'Aucun(e)',
    NoneCurrency: 'Choisir la devise',
    NoPayments: 'Il n\'y a pas de paiements.',
    NoPlannedExpenses: 'Il n\'y a pas de dépenses prévues.',
    NotBillable: 'Non facturable',
    NotBillableLabel: 'Non facturable',
    NotBilled: 'Non facturé',
    OpenRateCard: 'Ouvrir les cartes tarifaires',
    OutstandingPaymentBalance: 'Solde de paiement impayé',
    PaymentDescriptionWatermark: 'Description...',
    PaymentReceived: 'Paiement reçu',
    payments_total: '1#{0} paiement#{0} paiements',
    PaymentsOfSchedPayments: 'Paiements des paiements prévus',
    PercentageBilled: 'Pourcentage facturé',
    PercentageProjectBilled: 'Pourcentage facturé',
    Percentages: 'Pourcentage',
    PlannedExpenses: 'Dépenses prévues',
    PlannedExpensesListTitle: 'Prévu',
    ppFormat: '{0}pp',
    Profit: 'Bénéfice',
    ProfitQtip: 'Bénéfice = Coût facturable réel - Coût réel',
    ProjectActivityName: 'Nom du projet/de l\'activité',
    ProjectBilling: 'Facturation du projet',
    ProjectBillingIsBasedOn: 'La facturation du projet est basée sur ',
    ProjectBillingUtilization: 'Utilisation de la facturation',
    ProjectBudget: 'Budget de la main-d\'œuvre',
    ProjectCost: 'Coût interne du projet',
    ProjectCostVariance: 'Variance du coût du projet',
    ProjectEarnedValue: 'Valeur acquise du projet',
    ProjectEarnedValueInfo: 'Représente la santé du projet',
    ProjectExpectedRevenue: 'Revenu attendu du projet',
    ProjectFixedCostLabel: 'Coût fixe du projet',
    ProjectHourlyRateLabel: 'Taux horaire du projet',
    ProjectPayments: 'Paiements du projet',
    ProjectPlannedExpenses: 'Dépenses prévues du projet',
    ProjectPlannedExpensesInfo: 'Dépenses prévues pour un projet spécifique et dépenses prévues agrégées à partir de ses activités',
    ProjectProfit: 'Bénéfice du projet',
    ProjectProfitability: 'Rentabilité du projet',
    ProjectProfitabilityInfo: 'Représente le pourcentage de valeur créée par projet',
    ProjectTimeUsage: 'Utilisation du temps du projet',
    ProjectTimeUsageInfo: 'Affiche la quantité de temps budgétisée que nous avons utilisée, réelle en pourcentage des heures estimées',
    ProjectWorkInProgress: 'Travail en cours du projet',
    PymentsVsActualCost: 'Paiements vs coût réel',
    RateCardLabel: 'Carte tarifaire',
    Receipt: 'Reçu',
    Received: 'Reçu',
    ReceivedPaymentsListTitle: 'Reçu',
    RemainingInternalBudget: 'Budget restant',
    RemainingInternalBudgetQtip: 'Budget restant = Budget - Coût réel',
    RemainingInternalBudgetQtipForProject: 'Budget restant = Budget total - Coût réel',
    ResourceHourlyRateLabel: 'Taux horaire de la ressource',
    Revenue: 'Revenu',
    Scheduled: 'Prévu',
    ScheduledPaymentsListTitle: 'Prévu',
    set_targets: 'Définissez les cibles à l\'aide de',
    Settings: 'Paramètres',
    ShowAll: 'AFFICHER TOUT',
    ShowBreakdown: 'Afficher la répartition',
    ShowFull: 'AFFICHER L\'INTÉGRALITÉ',
    SPI: 'SPI',
    tab_Actual: 'Dépenses réelles',
    tab_expenses: 'Dépenses',
    tab_overview: 'Aperçu',
    tab_payments: 'Paiements',
    tab_Planned: 'Dépenses prévues',
    tab_Received: 'Paiements reçus',
    tab_Scheduled: 'Paiements prévus',
    tab_targets: 'Cibles',
    TargetBudget: 'Budget total',
    TargetLaborRevenue: 'Revenu de la main-d\'œuvre cible',
    TargetProfit: 'Bénéfice cible',
    TargetRevenue: 'Revenu cible',
    Targets: 'Cibles',
    targets_tab: 'Onglet des cibles',
    TargetsEACBilling: 'EAC facturable',
    TaskRateLabel: 'Tarif de l\'activité',
    TimeAndMaterial: 'Temps et matériel',
    TimeUsage: 'Utilisation du temps',
    TitleText: 'Données financières',
    total_billable: 'Total facturable',
    TotalBilled: 'Total facturé',
    TotalProjectBudget: 'Budget total du projet',
    TotalProjectPayments: 'Paiements totaux du projet',
    TotalProjectPaymentsInfo: 'Récapitulatif de tous les paiements effectués par tous les clients',
    TotalTargetRevenue: 'Revenu cible total',
    TrackProfitAs: 'Suivre les bénéfices comme',
    Validation_DateMandatory: 'La date est un champ obligatoire.',
    Validation_InvalidAmount: 'Le montant doit être un nombre positif.',
    Validation_InvalidDate: 'La date doit être au format « {0} ».',
    Validation_Range: 'La valeur n\'est pas comprise dans la plage attendue.',
    Variance: 'Variance',
    warning_currency: 'La devise est tirée de la carte tarifaire choisie',
    WorkInProgress: 'Travail en cours',
};
